export enum LoginSource {
    Organic = 'organic',
    NonOrganic = 'non-organic',
    DailyChatDrawer = 'daily-chat-drawer',
    DailyChatSubscribe = 'daily-chat-subscribe',
    DailyChat = 'daily-chat',
    DailyChatModal = 'daily-chat-modal',
}
